import { cloneDeep } from 'lodash-es';
import { statistics } from '@/api/dot/flow';
import { COPILOT_TRACKS, COPILOT_FILTER_TRACKS } from './report';

export default {
  data() {
    return {
      copilotVisible: false,
      // 错误筛选模式
      errorFilterMode: {
        isOpen: false,
        errorItem: {},
      },
      pageCache: {},
    };
  },
  methods: {
    openTermDialog(type, row) {
      // 选中译文气泡的场景
      if (type) {
        this.isShowLabel = false;
      }
      this.termDialogVisible = true;

      // 没有row：不是表格托选快捷添加
      // 加个延时：同一时间还有一个expose上报，不延时会导致相互影响
      row &&
        statistics(
          Object.assign({}, this.staParams, COPILOT_TRACKS.copilotTermClick, {
            sentId: row.id,
          }),
        );
    },
    handleCopilotWidgetClick() {
      this.copilotVisible = true;
      statistics(
        Object.assign({}, this.staParams, COPILOT_TRACKS.copilotClick),
      );
    },
    openQuickQA() {
      this.copilotVisible = true;
      statistics(
        Object.assign({}, this.staParams, COPILOT_TRACKS.copilotQAClick),
      );
    },
    // 开启错误筛选
    handleOpenFilterMode(errorItem) {
      this.errorFilterMode = {
        isOpen: true,
        errorItem,
      };
      this.pageCache = cloneDeep(this.page);
      this.page.size = 100;
      this.page.current = 1;
      this.loadPage();

      statistics(
        Object.assign(
          {},
          this.staParams,
          COPILOT_FILTER_TRACKS.openFilterMode,
          {
            event_params: errorItem.type,
          },
        ),
      );
    },
    // 关闭错误筛选
    handleCloseFilterMode() {
      this.errorFilterMode.isOpen = false;
      this.page.size = this.pageCache.size;
      this.page.total = this.pageCache.total;
      // 延迟重置page.current，否则会导致el-pagination组件计算有误
      this.$nextTick(() => {
        this.page = this.pageCache;
        this.loadPage();
      });

      const { errorItem } = this.errorFilterMode;
      statistics(
        Object.assign(
          {},
          this.staParams,
          COPILOT_FILTER_TRACKS.closeFilterMode,
          {
            event_params: errorItem.type,
          },
        ),
      );
    },
    // 翻译
    toTrans(type, row) {
      this.isShowLabel = false;
      this.copilotVisible = true;
      this.$nextTick(() => {
        // type用于判断是点击的原文、机翻译文还是pe译文
        this.$refs.copilotPanel.gptTrans(type, row);
      });

      statistics(
        Object.assign({}, this.staParams, COPILOT_TRACKS.copilotTranClick, {
          sentId: row.id,
        }),
      );
    },
    // 润色
    toPolish(type, row) {
      this.isShowLabel = false;
      this.copilotVisible = true;
      this.$nextTick(() => {
        this.$refs.copilotPanel.gptPolish(type, row);
      });

      statistics(
        Object.assign({}, this.staParams, COPILOT_TRACKS.copilotPolishClick, {
          sentId: row.id,
        }),
      );
    },
  },
};
